import styled from '@emotion/styled';
import { Box } from '@shared/helpers';

export const AZLogo = styled(Box)`
  cursor: pointer;
  img {
    height: 100%;
  }
`;
